export default {
  printWillStartAutomatically: 'چاپ گزارش به صورت خودکار شروع خواهد شد.',
  percentage: 'درصد',
  preparing: 'در حال آماده سازی گزارش',
  spring: 'بهار',
  summer: 'تابستان',
  autumn: 'پاییز',
  winter: 'زمستان',
  from: 'از',
  to: 'تا',
};
